/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import MuiSkeleton from '@mui/material/Skeleton';
import { stopPropagation } from '../../utils/listeners';
import * as S from './styled';

const CustomStyles = { bgcolor: 'var(--skeleton-bg-color)', height: '100%' };

const SkeletonBox = ({ count = 1, variant = 'rounded', width, height }) => (
  <S.Container onClick={stopPropagation} $width={width} $height={height}>
    {Array.from({ length: count }).map((_, idx) => (
      <MuiSkeleton key={idx} sx={CustomStyles} variant={variant} animation="wave" />
    ))}
  </S.Container>
);

SkeletonBox.propTypes = {
  count: PropTypes.number,
  variant: PropTypes.oneOf(['rounded', 'text', 'circular', 'rectangular']),
  /* Without a size the skeleton fills its container (original behavior) */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default SkeletonBox;
